import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { toast } from "react-toastify";
import Loading from "./Loading";
import { useMutation } from "@tanstack/react-query";
import { payableUpadate, payableUpadateRecurrence } from "../services/payable";
import { useUserStore } from "../stores/user";

type Props = {
  open: boolean;
  onClose: () => void;
  id: number | string | null;
  onAction?: () => void;
  isRecurring?: boolean | null;
};

const PayableDelete = ({ open, onClose, id, onAction, isRecurring }: Props) => {
  const { user } = useUserStore();

  const { mutate: cancelPayableRecurrence } = useMutation({
    mutationFn: payableUpadateRecurrence,
    onSuccess: () => {
      toast.success("Conta cancelada com sucesso.");
      onAction?.();
      onClose();
    },
    onError: () => {
      toast.error("Erro ao cancelar conta.");
    },
  });

  const { mutate, isPending } = useMutation({
    mutationFn: payableUpadate,
    onSuccess: () => {
      toast.success("Conta deletada com sucesso.");
      onAction?.();
      onClose();
    },
    onError: () => {
      toast.error("Erro ao deletar conta.");
    },
  });

  const handleAction = () => {
    if (!id || !user?.storeId) return;

    if (isRecurring) {
      mutate({
        id: Number(id),
        status: false,
      });
    } else {
      cancelPayableRecurrence({
        id: Number(id),
        status: "CANCELED",
      });
    }
  };

  return (
    <Dialog maxWidth="xs" open={open} onClose={() => onClose()}>
      <Loading loading={isPending} />
      <DialogContent sx={{ backgroundColor: "secondary.main" }}>
        <Grid2 container spacing={2} padding={1}>
          <Grid2 size={{ xs: 10, md: 11 }}>
            {!isRecurring && (
              <Typography variant="h2" fontSize={26} fontWeight={600}>
                Deletar Conta Recorrente
              </Typography>
            )}
            {isRecurring && (
              <Typography variant="h2" fontSize={26} fontWeight={600}>
                Deletar Pagamento
              </Typography>
            )}
          </Grid2>
          <Grid2 size={{ xs: 2, md: 1 }}>
            <IconButton onClick={() => onClose()}>
              <IconX style={styles.iconStyle} />
            </IconButton>
          </Grid2>
          <Grid2 size={12}>
            {!isRecurring && (
              <Typography variant="subtitle2" color="secondary.contrastText">
                Você realmente quer deletar esta conta recorrente?
              </Typography>
            )}
            {isRecurring && (
              <Typography variant="subtitle2" color="secondary.contrastText">
                Você realmente quer deletar este Pagamento?
              </Typography>
            )}
          </Grid2>
          <Grid2 size={12}>
            <Button
              fullWidth
              variant="contained"
              size="large"
              sx={{ backgroundColor: "red" }}
              onClick={handleAction}
            >
              Deletar conta
            </Button>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  );
};

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default PayableDelete;
